<template>
  <div>
    <label>Competência</label>
    <v-select
      v-model="competencia"
      :items="competencias"
      :item-text="item => displayCompetencia(item)"
      :item-value="item => item"
      :menu-props="{ bottom: true, offsetY: true }"
      :rules="formRules.required"
      style="text-transform: capitalize"
      flat
      solo
      dense
      outlined
    />
  </div>
</template>

<script>
import moment from "moment"
import { mapState } from "vuex";

function getCompetencias (numberOfMonths) {
  const now = new Date()
  const competencias = Array.from(
    Array(numberOfMonths).keys()
  )
    .map(value => moment(now)
      .subtract(value, 'months')
      .startOf('month')
      .toDate()
    )
  
  return competencias
}

export default {
  props: {
    value: Date,
    numberOfMonths: {
      type: Number,
      default: 12,
      required: false,
      validator: numberOfMonths => numberOfMonths > 0
    }
  },
  model: {
    props: 'value',
    event: 'change'
  },
  computed: {
    ...mapState({
        formRules: state => state.formRules
    }),  
    competencias: function () {
      return getCompetencias(this.numberOfMonths)
    },
    competencia: {
      get: function () {
        return this.value
      },
      set: function (val) {
        this.$emit('change', val)
      }
    },
  },
  methods: {
    displayCompetencia: function (date) {
      const formattedDate = moment(date).format('MMM YYYY')

      return formattedDate.charAt(0).toUpperCase() + formattedDate.slice(1)
    }
  },
  mounted: function () {
    this.competencia = this.competencias[0]
  }
}
</script>
